import React from "react";
import { Box, Typography, Container, Stack } from "@mui/material";

// about-us.tsx
// Route example: <Route path="/about" element={<AboutUs />} />

export default function AboutUs() {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom textAlign="center">
        About Us
      </Typography>

      <Stack spacing={4}>
        {/* About the Company */}
        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            About the Company
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Priya Beads</strong> is a trusted name in the world of beads and jewelry-making
            supplies, proudly based in Varanasi, India. With a deep connection to the city’s rich
            cultural heritage, we specialize in offering premium-quality beads that blend
            traditional artistry with modern design.
          </Typography>
          <Typography variant="body1">
            We are committed to providing a wide variety of beads in diverse styles, colors, and
            finishes to meet the needs of jewelry designers, artisans, and craft enthusiasts across
            the globe. Each product we deliver is carefully selected to ensure quality, durability,
            and elegance.
          </Typography>
        </Box>

        {/* Vision */}
        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Our Vision
          </Typography>
          <Typography variant="body1">
            To be a leading global supplier of beads, inspiring creativity and craftsmanship while
            upholding the values of quality and trust.
          </Typography>
        </Box>

        {/* Mission */}
        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Our Mission
          </Typography>
          <Typography
            variant="body1"
            component="ul"
            sx={{ pl: 3, "& li": { mb: 1.5, lineHeight: 1.8 } }}
          >
            <li>To deliver high-quality beads that meet international standards</li>
            <li>To support artisans, designers, and businesses with reliable supplies</li>
            <li>
              To preserve the traditional charm of Varanasi while embracing modern trends
            </li>
          </Typography>
          <Typography variant="body1" sx={{ mt: 1.5 }}>
            At Priya Beads, we believe that every bead carries a story. Our goal is to help you
            create jewelry and art that is not only beautiful but also meaningful.
          </Typography>
        </Box>

        {/* About the Owner */}
        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            About the Owner
          </Typography>
          <Typography variant="body1" gutterBottom>
            Priya Beads was founded and is led by <strong>Mr. Nilesh Jaiswal</strong>, whose vision
            and passion for creativity brought this brand to life. With a strong entrepreneurial
            spirit and deep roots in Varanasi’s traditional craft culture, he established Priya
            Beads with the goal of making premium-quality beads accessible to jewellery makers,
            artisans, and designers worldwide.
          </Typography>
          <Typography variant="body1" gutterBottom>
            Under his leadership, Priya Beads has grown from a small local business into a trusted
            name in the bead and jewellery-making industry. His dedication to quality, innovation,
            and customer satisfaction continues to guide the company’s growth and reputation.
          </Typography>
          <Typography variant="body1">
            Mr. Jaiswal strongly believes that beads are more than just decorative pieces—they are
            symbols of art, tradition, and personal expression. With this philosophy, he ensures
            that every product from Priya Beads reflects not only beauty but also meaning and
            authenticity.
          </Typography>
        </Box>
      </Stack>
    </Container>
  );
}
